import React from 'react';
import { motion } from 'framer-motion';

function Home({ t }) {
  const home = t.home;
  const shopUrl = home.shopify.url;

  return (
    <main className="brand-home">
      <section className="brand-hero" id="home">
        <motion.div
          className="brand-hero-media"
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: 'easeOut' }}
        >
          <img src={home.hero.image} alt={home.hero.imageAlt} />
        </motion.div>

        <motion.div
          className="brand-hero-copy"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.8, ease: 'easeOut' }}
        >
          <p className="brand-kicker">{home.hero.kicker}</p>
          <h1>{home.hero.title}</h1>
          <p>{home.hero.subtitle}</p>
          <div className="brand-hero-specs" aria-label={home.hero.specLabel}>
            {home.hero.specs.map((spec) => (
              <span key={spec}>{spec}</span>
            ))}
          </div>
          <div className="brand-hero-actions">
            <a className="brand-action brand-action-primary" href={shopUrl} target="_blank" rel="noreferrer">
              {home.hero.shopCta}
            </a>
            <a className="brand-action" href="#collection">
              {home.hero.collectionCta}
            </a>
          </div>
        </motion.div>
      </section>

      <section className="brand-product-view" aria-label={home.productView.ariaLabel}>
        <motion.div
          className="product-view-label"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span>{home.productView.kicker}</span>
          <p>{home.productView.title}</p>
        </motion.div>

        <div className="product-view-grid">
          {home.productView.items.map((item, index) => (
            <motion.figure
              className="product-view-frame"
              key={item.code}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.06, duration: 0.6 }}
            >
              <img src={item.image} alt={item.alt} />
              <figcaption>{item.code}</figcaption>
            </motion.figure>
          ))}
        </div>
      </section>

      <section className="brand-section brand-categories" id="collection">
        <motion.div
          className="brand-section-heading"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="brand-kicker">{home.collection.kicker}</p>
          <h2>{home.collection.title}</h2>
        </motion.div>

        <div className="category-grid">
          {home.collection.items.map((category, index) => (
            <motion.article
              className="category-tile"
              key={category.code}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08, duration: 0.65 }}
            >
              <img src={category.image} alt={category.alt} loading="lazy" />
              <div>
                <span>{category.code}</span>
                <h3>{category.title}</h3>
                {category.concept && <strong>{category.concept}</strong>}
                <p>{category.subtitle}</p>
              </div>
            </motion.article>
          ))}
        </div>

        <motion.div
          className="series-horizon"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span>{home.collection.note}</span>
        </motion.div>
      </section>

      <section className="brand-philosophy" id="about">
        <motion.div
          className="philosophy-image"
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img src={home.philosophy.image} alt={home.philosophy.imageAlt} />
        </motion.div>

        <motion.div
          className="philosophy-copy"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="brand-kicker">{home.philosophy.kicker}</p>
          <h2>{home.philosophy.title}</h2>
          <p>{home.philosophy.description}</p>
          <div className="philosophy-points">
            {home.philosophy.points.map((point) => (
              <span key={point}>{point}</span>
            ))}
          </div>
        </motion.div>
      </section>

      <section className="shopify-gateway" id="shop">
        <motion.div
          className="shopify-gateway-inner"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="brand-kicker">{home.shopify.kicker}</p>
          <h2>{home.shopify.title}</h2>
          <p>{home.shopify.description}</p>
          <a className="brand-action brand-action-primary" href={shopUrl} target="_blank" rel="noreferrer">
            {home.shopify.cta}
          </a>
        </motion.div>
      </section>
    </main>
  );
}

export default Home;
